import * as React from 'react';
import Slider from '@teliaee/react-slick';
import Button from '@telia-front/button';
import Image from '@telia-front/image';
import { Placeholder } from './placeholder';
import { usePlaceholderArray, useSliderSettings } from './utils';
const Pager = (props) => {
    const { afterChange, asNavFor, items, nextArrowText, prevArrowText, placeholder, sliderRef, onItemClick, onNextButtonClick, onPrevButtonClick } = props;
    const placeholders = usePlaceholderArray(items.length);
    const sliderSettings = useSliderSettings(items.length + placeholders.length, {
        arrows: true,
        asNavFor: asNavFor || undefined,
        nextArrow: React.createElement(NextButton, { text: nextArrowText, clickCallback: onNextButtonClick }),
        prevArrow: React.createElement(PrevButton, { text: prevArrowText, clickCallback: onPrevButtonClick }),
        swipe: false,
        variableWidth: true,
        afterChange,
    });
    return (React.createElement("div", { className: BEM(items.length + placeholders.length) },
        React.createElement(Slider, Object.assign({ className: "product-comparison__pager-slider" }, sliderSettings, { ref: sliderRef }),
            items.map((item, index) => {
                const { image } = item;
                return (React.createElement("button", { type: "button", className: "product-comparison__pager-item", key: index, tabIndex: -1, onClick: event => {
                        event.preventDefault();
                        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(index);
                    } },
                    React.createElement(Image, Object.assign({}, image, { className: "product-comparison__pager-item-image" }))));
            }),
            placeholders.map((_i, index) => {
                return (React.createElement("div", { className: "product-comparison__pager-item", key: `placeholder-${index}` }, index === 0 && React.createElement(Placeholder, Object.assign({}, placeholder))));
            }))));
};
const BEM = (itemCount) => {
    const classArray = ['product-comparison__pager'];
    if (itemCount) {
        classArray.push(`product-comparison__pager--${itemCount}`);
    }
    return classArray.join(' ');
};
const NextButton = (props) => {
    var _a;
    const isDisabled = (_a = props.className) === null || _a === void 0 ? void 0 : _a.includes('slick-disabled');
    const clickHandler = (event) => {
        event.preventDefault();
        if (props.clickCallback) {
            props.clickCallback();
        }
        if (props.onClick) {
            props.onClick(event);
        }
    };
    return (React.createElement(Button, Object.assign({}, props, { onClick: clickHandler, disabled: isDisabled, variant: "secondary", size: "small", icon: "#arrow-right", className: `${props.className} product-comparison__nav product-comparison__nav--next`, attributes: { tabIndex: -1 } })));
};
const PrevButton = (props) => {
    var _a;
    const isDisabled = (_a = props.className) === null || _a === void 0 ? void 0 : _a.includes('slick-disabled');
    const clickHandler = (event) => {
        event.preventDefault();
        if (props.clickCallback) {
            props.clickCallback();
        }
        if (props.onClick) {
            props.onClick(event);
        }
    };
    return (React.createElement(Button, Object.assign({}, props, { onClick: clickHandler, disabled: isDisabled, variant: "secondary", size: "small", icon: "#arrow-left", className: `${props.className} product-comparison__nav product-comparison__nav--prev`, attributes: { tabIndex: -1 } })));
};
export default Pager;
